import { REPORTS_DEFAULT_FILTERS } from '@constants/Reports/reportsDefaultToolbar.constants'
import { ReportsKpiMetric } from '@dataTypes/reports.type'

export const MARKETING_CAMPAIGN_FILTERS = REPORTS_DEFAULT_FILTERS

export const MARKETING_CAMPAIGN_KPI_METRICS: ReportsKpiMetric[] = [
  {
    id: 'campaign-roi',
    title: 'Campaign ROI',
    value: '473',
    unitInline: '%',
    footer: 'Tracked Revenue ROI',
    tone: 'positive',
  },
  {
    id: 'cpa',
    title: 'CPA',
    value: '$176',
    footer: 'Spent/new patients',
  },
  {
    id: 'ltv-cac',
    title: 'LTV to CAC',
    value: '9.26x',
    footer: 'Weighted LTV/CPA',
    tone: 'positive',
  },
  {
    id: 'lead-new-conv',
    title: 'Lead → New Conversion',
    value: '26',
    unitInline: '%',
    footer: 'New patients/leads',
    tone: 'positive',
  },
]

/** Monthly spend ($K) vs email outcomes — dual-axis grouped bars. */
export const SPENT_VS_NEW_PATIENTS_MONTHLY = [
  { month: 'Jan', spentK: 4.5, bounced: 30, unsubscribed: 14 },
  { month: 'Feb', spentK: 4.1, bounced: 28, unsubscribed: 16 },
  { month: 'Mar', spentK: 3.95, bounced: 26, unsubscribed: 18 },
  { month: 'Apr', spentK: 4.25, bounced: 24, unsubscribed: 14 },
  { month: 'May', spentK: 4.0, bounced: 22, unsubscribed: 12 },
  { month: 'Jun', spentK: 3.6, bounced: 20, unsubscribed: 10 },
]

export const CHANNEL_ROI_BAR_ROWS = [
  { id: 'google', label: 'Google Ads', roi: 54 },
  { id: 'meta', label: 'Meta Ads', roi: 50 },
  { id: 'email', label: 'Email', roi: 41 },
  { id: 'sms', label: 'SMS', roi: 14 },
]

export const CONVERSION_FUNNEL_STAGES = [
  { id: 'leads', label: 'Leads', count: 480 },
  { id: 'appointments', label: 'Appointments', count: 280 },
  { id: 'newPatients', label: 'New Patients', count: 127 },
]

export type MarketingChannelDetailRow = {
  id: string
  channel: string
  spend: string
  newPatients: number
  cpa: string
  ltv: string
  ltvCac: string
  leadToNew: string
}

export const MARKETING_CHANNEL_DETAIL_ROWS: MarketingChannelDetailRow[] = [
  {
    id: 'google',
    channel: 'Google Ads',
    spend: '$12,000.00',
    newPatients: 54,
    cpa: '$222.00',
    ltv: '$1,800.00',
    ltvCac: '8.1',
    leadToNew: '30%',
  },
  {
    id: 'meta',
    channel: 'Meta Ads',
    spend: '$9,000.00',
    newPatients: 41,
    cpa: '$220.00',
    ltv: '$1,650.00',
    ltvCac: '7.5',
    leadToNew: '29%',
  },
  {
    id: 'email',
    channel: 'Email',
    spend: '$900.00',
    newPatients: 18,
    cpa: '$50.00',
    ltv: '$1,400.00',
    ltvCac: '28.0',
    leadToNew: '20%',
  },
  {
    id: 'sms',
    channel: 'SMS',
    spend: '$450.00',
    newPatients: 14,
    cpa: '$32.00',
    ltv: '$1,200.00',
    ltvCac: '37.3',
    leadToNew: '20%',
  },
]
